import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronDownCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	height: 40,
	viewBox: "0 0 40 40",
	width: 40,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 20,
		cy: 20,
		fill: "#fff",
		r: 20
	}), /* @__PURE__ */ _jsx("path", {
		d: "m10 16 10 10 10-10",
		stroke: "currentColor",
		strokeMiterlimit: 10,
		strokeWidth: 1.5
	})]
});
export default SvgChevronDownCircle;
